export const user = 'appUser'
export const updateTime = 'appUpdateTime'
export const updateStyle = 'appUpdateStyle'
export const dontReload = 'appDontReload'
export const language = 'appLanguage'
